import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Navigation from "./components/Navigation";
import Dashboard from "./components/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import AllUsers from "./components/AllUsers";
import ViewProduct from "./components/ViewProduct";
import ViewService from "./components/ViewService";
import Login from "./components/LogIn";
import Categories from "./components/Categories";
import Variants from "./components/Variants";
import AllProducts from "./components/AllProducts";
import AllServices from "./components/AllServices";
import AllOrders from "./components/AllOrders";
import UserReviews from "./components/UserReviews";
import AddNewProduct from "./components/AddNewProduct";
import AddNewService from "./components/AddNewService";
import ViewCountryNews from "./components/ViewCountryNews";
import Countries from "./components/Countries";
import Settings from "./components/Settings";
import { AuthProvider } from "./components/AuthContext";
import { updateCurrentUser } from "firebase/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import NewsFeed from "./components/NewsFeed";
import ConventionAndTreaties from "./components/ConventionAndTreaties";
import UNResolution from "./components/UNResolution";
import Institutions from "./components/Institutions";
import VisaRequirement from "./components/VisaRequirement";
import DiplomaticList from "./components/DiplomaticList";
import AddBooks from "./components/AddBooks";
import AddScholarship from "./components/AddScholarship";
import AddSchools from "./components/AddSchools";
import AddCuturalResources from "./components/AddCulturalResources";
import AllCodes from "./components/AllCodes";
import SendEmails from "./components/SendEmails";
import SendNotifications from "./components/SendNotifications";
import ManageSubscription from "./components/ManageSubscription";

function App() {
  return (
    <>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/" element={<Navigation />}>
              <Route
                path="/AllUsers"
                element={
                  <ProtectedRoute>
                    <AllUsers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Categories"
                element={
                  <ProtectedRoute>
                    <Categories />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Variants"
                element={
                  <ProtectedRoute>
                    <Variants />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AllProducts"
                element={
                  <ProtectedRoute>
                    <AllProducts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AllServices"
                element={
                  <ProtectedRoute>
                    <AllServices />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AllOrders"
                element={
                  <ProtectedRoute>
                    <AllOrders />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ConventionAndTreaties"
                element={
                  <ProtectedRoute>
                    <ConventionAndTreaties />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/UNResolutions"
                element={
                  <ProtectedRoute>
                    <UNResolution />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Institutions"
                element={
                  <ProtectedRoute>
                    <Institutions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/visarequirement"
                element={
                  <ProtectedRoute>
                    <VisaRequirement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AllFeedbacks"
                element={
                  <ProtectedRoute>
                    <UserReviews />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/newsfeed"
                element={
                  <ProtectedRoute>
                    <NewsFeed />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewProduct/:DocId"
                element={
                  <ProtectedRoute>
                    <ViewProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewService/:DocId"
                element={
                  <ProtectedRoute>
                    <ViewService />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddNewProduct/"
                element={
                  <ProtectedRoute>
                    <AddNewProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddNewService/"
                element={
                  <ProtectedRoute>
                    <AddNewService />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Countries/"
                element={
                  <ProtectedRoute>
                    <Countries />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Codes/"
                element={
                  <ProtectedRoute>
                    <AllCodes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddNewProduct/:DocId"
                element={
                  <ProtectedRoute>
                    <AddNewProduct />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddNewService/:DocId"
                element={
                  <ProtectedRoute>
                    <AddNewService />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewCountryNews/:DocId"
                element={
                  <ProtectedRoute>
                    <ViewCountryNews />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/DiplomaticList"
                element={
                  <ProtectedRoute>
                    <DiplomaticList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddBooks"
                element={
                  <ProtectedRoute>
                    <AddBooks />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddScholarship"
                element={
                  <ProtectedRoute>
                    <AddScholarship />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddSchools"
                element={
                  <ProtectedRoute>
                    <AddSchools />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddCuturalResources"
                element={
                  <ProtectedRoute>
                    <AddCuturalResources />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/SendEmails"
                element={
                  <ProtectedRoute>
                    <SendEmails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/SendNotifications"
                element={
                  <ProtectedRoute>
                    <SendNotifications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ManageSubscription"
                element={
                  <ProtectedRoute>
                    <ManageSubscription />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
